export default __webpack_public_path__ + "static/media/background.e579bd86.jpg";